export default function NotFoundPage() {
  return (
    <div>
      <h1>Nie znaleziono formularza</h1>
    </div>
  );
}
